import React from 'react'
import styled from 'styled-components';
import { connect } from 'react-redux'
import Plx from "react-plx";
import pricing2 from '../assets/img/pricing2.png'
import pricing3 from '../assets/img/pricing3.png'
import pricing4 from '../assets/img/pricing4.png'
import searching from '../assets/img/searching-magnifying-glass.svg'
import television from '../assets/img/television.svg'
import edit from '../assets/img/edit-3.svg'

const renderFunction = (props) => {
    const {messages} = props
    return (
        <Container>
            <FunctionTitle>
                <div>{messages.pricing_major}</div>
                <FunctionWrap>
                    <Function>
                        <FunctionPicture picture={searching}/>
                        <SubTitle marginTop={'8px'}>{messages.pricing_outreach}</SubTitle>
                    </Function>
                    <Function>
                        <FunctionPicture picture={television}/>
                        <SubTitle marginTop={'8px'}>{messages.pricing_big_data}</SubTitle>
                    </Function>
                    <Function>
                        <FunctionPicture picture={edit}/>
                        <SubTitle marginTop={'8px'}>{messages.pricing_project_management}</SubTitle>
                    </Function>
                </FunctionWrap>
                {/* <Email {...props}/> */}
            </FunctionTitle>
        </Container>
    )
}
const renderMurmur = (messages) => {
    return (
        <div>            
            <MurmurContainer >
                <MurmurWrap>            
                    <Title>
                        <div >{messages.pricing_we_know_you}</div>
                    </Title>
                    <SubTitle>
                        <div>{messages.pricing_data_tool}</div>
                        <br/>
                        <div>{messages.pricing_professional_analysis}</div>
                    </SubTitle>
                </MurmurWrap>
                <MurmurPicture picture={pricing2}/>
            </MurmurContainer>
            <MurmurContainer >
                <MurmurPicture picture={pricing3} left/>                
                <MurmurWrap right>
                    <Title>
                        <div>{messages.pricing_control}</div>
                    </Title>
                    <SubTitle>
                        <div>{messages.pricing_search_tool_01}</div>
                        <br/>
                        <div>{messages.pricing_search_tool_02}</div>
                    </SubTitle>
                </MurmurWrap>
            </MurmurContainer>
            <MurmurContainer >
                <MurmurWrap>
                    <Title>
                        <div>{messages.prcing_easy_plan}</div>
                    </Title>
                    <SubTitle>
                        <div>{messages.prcing_convenient}</div>
                        <br/>
                        <div>{messages.prcing_export}</div>
                        <br/>
                        <div>{messages.prcing_proposal_success}</div>
                    </SubTitle>
                </MurmurWrap>
                <MurmurPicture picture={pricing4}/>
            </MurmurContainer>
        </div>        
    )
}
const Jumbotron = (props) => {
    const { messages } = props
    return (
        <React.Fragment>
            {renderFunction(props)}
            {renderMurmur(messages)}
            {/*renderTitle(props)*/}
        </React.Fragment>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(Jumbotron);
const fadeIn = [
    {
        start: 'self',
        duration: 300,
        properties: [
            {
                startValue: 0.25,
                endValue: 1,
                property: "opacity"
            },
            {
                startValue: 50,
                endValue: 0,
                property: "translateY"
            }
        ]
    }
];
const Container = styled(Plx).attrs({
    parallaxData: fadeIn
}) `
    display: flex;
    flex-direction: ${props => props.column ? 'column' : 'row'};
    justify-content: ${props => props.column ? '' : 'space-between'};
    align-items: ${props => props.column ? 'center' : ''};
    width: 900px;
    padding: 48px;
    margin-bottom: 32px;
    background-color: #fff;
    /* box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);          */
    color: #787878;
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 0 20px 32px 20px;;
        padding: 20px;
        flex-direction: column;
    }  
`
const Title = styled.div`
    display: flex;
    flex-direction: column;
    text-align:center;
    align-items:  ${props => props.left ? '' : 'center'};
    width: ${props => props.right ? 'calc(100% + 28px)' : '100%'};
    font-size: 24px;
    font-weight: 500;
    transform: ${props => props.right ? 'translateX(-28px)' : ''};
    @media (max-width: 900px){
        font-size: 16px;
    }  
`
const SubTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.center ? 'center' : ''};
    margin-top: ${({ marginTop}) => marginTop ? marginTop : '24px'};
    font-size: 16px;
    font-weight: ${props => props.bold ? '500' : '300'};
    text-align: center;
    @media (max-width: 900px){
        font-size: 12px;
    }  
`
const FunctionTitle = Title.extend`
    font-size: 36px;
    @media (max-width: 900px){
        font-size: 20px;
    }
`
const FunctionWrap = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 24px;
    padding: 0 90px;
    @media (max-width: 900px){
        padding: 0;
    }
`
const Function = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const FunctionPicture = styled.div`
    width: 140px;
    height: 140px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 75%;
    background-image: ${props => `url(${props.picture})`};
    border-radius: 100%;
    @media (max-width: 900px){
        width: 80px;
        height: 80px;
    }
`
// const MurmurContainer = Container.extend`
//     padding: 0;
//     overflow: hidden;
// `
const MurmurContainer = styled(Plx).attrs({
    parallaxData : fadeIn 
}) `
    display: flex;
    flex-direction: ${props => props.column ? 'column' : 'row'};
    justify-content: ${props => props.column ? '' : 'space-between'};
    align-items: ${props => props.column ? 'center' : ''};
    width: 900px;
    padding: 0;
    margin-bottom: 32px;
    background-color: #fff;
    /* box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);          */
    overflow: hidden;
    color: #787878;
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 0 20px 32px 20px;;
        flex-direction: column;
    }    
`
const MurmurWrap = styled.div`
    width: 50%;
    height: auto;
    padding: 48px;
    @media (max-width: 900px){
        width: 100%;
        padding: 20px;
    }  
`
const MurmurPicture = styled.div`
    position: relative;;
    width: 50%;
    height: auto;
    /* transform: ${props => props.left ? 'translateX(-48px) skew(10deg)' : 'translateX(48px) skew(-10deg)'}; */
    overflow: hidden;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${props => `url(${props.picture})`};
    @media (max-width: 900px){
        width: 100%;
    } 
`


// WEBPACK FOOTER //
// ./src/Pricing/Jumbotron.js